import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ComponentBase, RentalObjectInfo, ObjectTypeInfo } from 't4core';


@Component({
    selector: 'app-loading-screen',
    templateUrl: './loading-screen.component.html',
    styleUrls: ['./loading-screen.component.css'],
    standalone: false
})
export class LoadingScreenComponent extends ComponentBase implements OnInit {
  @Input() public title: string;
  @Input() public description: string;
  @Input() public centered: boolean = false;
  @Input() public invertedColor: boolean = false;
  @Output() public viewLoaded = new EventEmitter<string>();

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.viewLoaded.emit('Done');
    }, 1000);
  }
 
}
